module.exports = __webpack_public_path__ + "img/logo-dark.9f8186ae.svg";